"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCorporateFees = void 0;
const enums_1 = require("../types/enums");
const constants_1 = require("../constants");
const getCorporateFees_1 = require("./fees/getCorporateFees");
const calculateSimpleFees_1 = require("./calculateSimpleFees");
/**
 * Calculates the total fee amount for a donation based on provider and application fees
 */
const calculateTotalFeeAmount = ({ baseAmount, providerFeeRate, applicationFeeRate, areFeesCovered, }) => (0, calculateSimpleFees_1.calculateSimpleFee)({
    amount: baseAmount,
    relative: providerFeeRate + applicationFeeRate,
    coverFees: areFeesCovered,
});
/**
 * Determines if fees should be covered based on who is covering them
 */
const shouldCoverFees = ({ feeCoveredBy, coverFees }) => feeCoveredBy === enums_1.FeeCoveredBy.Deed || feeCoveredBy === enums_1.FeeCoveredBy.Company ? false : coverFees;
const calculateCorporateFees = ({ amount = 0, // Decimal Amount for specified currency e.g: 10 or 10.00 USD
coverFees = false, donationProvider = undefined, feeCoveredBy = enums_1.FeeCoveredBy.User, applicationFeeSetting = constants_1.DEFAULT_APPLICATION_FEE_CORPORATE, }) => {
    const areFeesCovered = shouldCoverFees({ feeCoveredBy, coverFees });
    // Get corporate fees based on donation provider
    const { applicationFee, providerFee, ppgfFee } = (0, getCorporateFees_1.getCorporateFees)({
        donationProvider,
        includeDeedFee: feeCoveredBy !== enums_1.FeeCoveredBy.Deed,
        applicationFeeSetting,
    });
    const totalFeeAmount = calculateTotalFeeAmount({
        baseAmount: amount,
        providerFeeRate: providerFee,
        applicationFeeRate: applicationFee,
        areFeesCovered,
    });
    const totalAmount = areFeesCovered ? totalFeeAmount + amount : amount;
    // In theory it should be toFixed(2), but we currently don't know if we should round up or down and only try to avoid having a lot decimals
    const providerFeeAmount = parseFloat((totalAmount * (providerFee / 100)).toFixed(5));
    const applicationFeeAmount = parseFloat((totalAmount * (applicationFee / 100)).toFixed(5));
    const result = {
        totalFeeAmount,
        applicationFeeAmount,
        providerFeeAmount,
    };
    // Add PPGF fee amount if applicable
    if (ppgfFee) {
        result.ppgfFeeAmount = totalAmount * (ppgfFee / 100);
    }
    return result;
};
exports.calculateCorporateFees = calculateCorporateFees;
//# sourceMappingURL=calculateCorporateFees.js.map